import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getItemWebStorage } from "../../../features/webStorageSaver";
import ContentHeader from "../../../widgets/contentHeader/ContentHeader";
import LoaderWrapper from "../../../widgets/loaderWrapper/LoaderWrapper";
import ToastMessageContainer from "../../../widgets/toastMessageContainer/ToastMessageContainer";
import { useFetchObjectDocumentsQuery, useFetchRoadDocumentsQuery, useFetchRoadLandRightDocumentInfoQuery } from "../../../api/rtk/base/slices/documentsApiSlice";
import DocumentViewerPDF from "../../../widgets/documents/documentViewerWidgets/DocumentViewerPDF";
import DocumentViewerImage from "../../../widgets/documents/documentViewerWidgets/DocumentViewerImage";
import DocumentViewerDOCX from "../../../widgets/documents/documentViewerWidgets/DocumentViewerDOCX";

const PDFDocumentViewerExtensions = ['pdf', '.pdf']
const ImageDocumentViewerExtensions = ['jpg', '.jpg', 'jpeg', '.jpeg', 'png', '.png', 'gif', '.gif', 'tiff', '.tiff']
const DOCXDocumentViewerExtensions = ['docx', '.docx']

export default function DocumentViewerPage() {
    const { documentId, roadId, objectTypeName, objectId, landRightDocumentId }: any = useParams()
    const [documentExtension, setDocumentExtension] = useState<any>(null)
    const [documentName, setDocumentName] = useState<any>(null)
    const addressTypes = getItemWebStorage('addressTypes')
    const urlType = addressTypes?.find((type: any) => type.name === objectTypeName) != null ? `address` : `objects`

    // запрос на получение документов дороги (отправляется при наличии id дороги)
    const {
        data: roadDocuments,
        isFetching: roadDocumentsAreFetching,
        isError: errorRoadDocuments
    } = useFetchRoadDocumentsQuery({ roadId }, { skip: !roadId })

    // запрос на получение документов объекта (отправляется при наличии id объекта)
    const {
        data: objectDocuments,
        isFetching: objectDocumentsAreFetching,
        isError: errorObjectDocuments
    } = useFetchObjectDocumentsQuery({ urlType, objectType: objectTypeName, objectId }, { skip: !objectId })

    const {
        data: landRightDocument,
        isFetching: landRightDocumentAreFetching,
        isError: errorLandRightDocument
    } = useFetchRoadLandRightDocumentInfoQuery({ id: landRightDocumentId }, { skip: !landRightDocumentId })

    useEffect(() => {
        let document
        if (roadDocuments?.value) {
            document = roadDocuments?.value.find((document: any) => document.DocumentID == documentId)
        } else if (objectDocuments?.value) {
            document = objectDocuments?.value.find((document: any) => document.DocumentID == documentId)
        } else if (landRightDocument) {
            document = landRightDocument
        }
        if (document) {
            const extension = document?.FileExtension?.toLowerCase();
            const name = document?.Name
            if (extension) setDocumentExtension(extension)
            if (name) setDocumentName(name)
        }
    }, [roadDocuments, objectDocuments, landRightDocument])

    const documentIsPDF = PDFDocumentViewerExtensions.includes(documentExtension)
    const documentIsImage = ImageDocumentViewerExtensions.includes(documentExtension)
    const documentIsDOCX = DOCXDocumentViewerExtensions.includes(documentExtension)

    return (
        <>
            <ContentHeader title={documentName} />
            <div className="document-viewer-page-div">
                <ToastMessageContainer />
                <LoaderWrapper isLoading={!documentExtension}>
                    {documentIsPDF &&
                        <DocumentViewerPDF />
                    }
                    {documentIsImage &&
                        <DocumentViewerImage />
                    }
                    {documentIsDOCX &&
                        <DocumentViewerDOCX />
                    }
                </LoaderWrapper>
            </div>
        </>
    )
}
